import React, { Component } from 'react'

import Wopi360Start from './Wopi360Start'
import Wopi360Setup from './Wopi360Setup'
import Wopi360Questions from './Wopi360Questions'

export default class Wopi360Questionnaire extends Component {
  render() {
    const {
      isStarted,
      questions,
      openQuestions,
      role,
      target,
      isTarget,
      activeQuestionIndex,
      language,
      onAnswer,
      onOpenAnswer,
      onStart,
      onSelectRole,
      activeQuestionAnswer
    } = this.props

    if (!isStarted) {
      return <Wopi360Start target={target} onStart={onStart} language={language} />
    } else if (!role && !isTarget) {
      return <Wopi360Setup target={target} onSelectRole={onSelectRole} language={language} />
    }

    return (
      <Wopi360Questions
        language={language}
        target={target}
        isTarget={isTarget}
        questions={questions}
        openQuestions={openQuestions}
        activeQuestionIndex={activeQuestionIndex}
        activeQuestionAnswer={activeQuestionAnswer}
        onAnswer={onAnswer}
        onOpenAnswer={onOpenAnswer}
        refreshQuestionnaire={this.props.refreshQuestionnaire}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360Questionnaire.js